<script setup lang="ts">
import type Elastic from '../omnibox/Elastic.vue';
import type Modal from '#layers/core/app/layouts/_partials/default/omnibox/Modal.vue';

const modalRef = ref<InstanceType<typeof Modal>>();
const elasticRef = ref<InstanceType<typeof Elastic>>();
const loading = ref(false);
const routesResults = ref(false);
const elasticResults = ref(false);
const results = computed(() => routesResults.value || elasticResults.value);
const query = ref('');

function onClear()
{
    loading.value = false;
    routesResults.value = false;
    elasticResults.value = false;
    query.value = '';
    elasticRef.value?.clear();
}

function onClose()
{
    modalRef.value?.close();
}
</script>

<template>
    <LayoutsDefaultOmniboxModal ref="modalRef" v-model:query="query" :loading="loading" :results="results" @clear="onClear">
        <LayoutsDefaultOmniboxRoutes v-model:loading="loading" v-model:results="routesResults" :query="query" @close="onClose" />
        <LayoutsDefaultOmniboxElastic ref="elasticRef" v-model:loading="loading" v-model:results="elasticResults" :query="query" @close="onClose" />
    </LayoutsDefaultOmniboxModal>
</template>
